"use client";

import { trackEvent } from "@/utils/analytics/track-event";
import { useEffect } from "react";

interface UnitPageTrackingProps {
	unitId: string;
	unitName: string;
	price?: number;
}

export function UnitPageTracking({ unitId, unitName, price }: UnitPageTrackingProps) {
	useEffect(() => {
		// Track unit page view
		trackEvent({
			facebook: {
				event: "ViewContent",
				options: {
					content_type: "home_listing",
					content_ids: [unitId],
					content_name: unitName,
					city: "Bangalore",
					value: price ? parseFloat(price.toString()) : undefined,
					currency: "INR",
				},
			},
			google: {
				event: "view_item",
				options: {
					currency: "INR",
					value: price ? parseFloat(price.toString()) : undefined,
					items: [
						{
							item_id: unitId,
							item_name: unitName,
							item_category: "unit",
							price: price ? parseFloat(price.toString()) : undefined,
							quantity: 1,
						},
					],
				},
			},
			matomo: {
				event: "view-unit",
				options: {
					category: "property",
				},
			},
		});
	}, [unitId, unitName, price]);

	return null;
}
